import { render, staticRenderFns } from "./ResourceTiles.vue?vue&type=template&id=45998198&scoped=true"
import script from "./ResourceTiles.vue?vue&type=script&lang=js"
export * from "./ResourceTiles.vue?vue&type=script&lang=js"
import style0 from "./ResourceTiles.vue?vue&type=style&index=0&id=45998198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45998198",
  null
  
)

export default component.exports